export const FETCH_CATEGORY = "FETCH_CATEGORY";
export const FETCH_CATEGORY_FAILURE = "FETCH_CATEGORY_FAILURE";
export const FETCH_CATEGORY_SUCCESS = "FETCH_CATEGORY_SUCCESS";
